import React from 'react';

const DEFAULT_SIZE = 30;

export const InfoIcon = ({ fill, width = DEFAULT_SIZE, height = DEFAULT_SIZE, className, style, ...rest }) => {
    const sizeStyle = {
        width,
        height,
        minWidth: width,
        minHeight: height,
        flexShrink: 0,
        ...style,
    };
    return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={sizeStyle} {...rest}>
            <g clipPath="url(#clip0_70_82)">
                <path d="M31.7534 9.26172C19.3494 9.26172 9.26074 19.3503 9.26074 31.7544C9.26074 44.1584 19.3494 54.2471 31.7534 54.2471C44.1575 54.2471 54.2461 44.1584 54.2461 31.7544C54.2461 19.3503 44.1575 9.26172 31.7534 9.26172Z" fill="#E1F4D3" />
                <path d="M31.7551 6.61548C17.8956 6.61548 6.61621 17.8949 6.61621 31.7543C6.61621 45.6138 17.8956 56.8932 31.7551 56.8932C45.6145 56.8932 56.8939 45.6138 56.8939 31.7543C56.8939 17.8949 45.6145 6.61548 31.7551 6.61548ZM31.7551 54.247C19.351 54.247 9.26241 44.1584 9.26241 31.7543C9.26241 19.3503 19.351 9.26167 31.7551 9.26167C44.1591 9.26167 54.2477 19.3503 54.2477 31.7543C54.2477 44.1584 44.1591 54.247 31.7551 54.247Z" fill="#1C452B" />
                <path d="M31.7537 27.6125C32.513 27.6125 33.1343 28.2665 33.1343 29.0658V39.9655C33.1343 40.7648 32.513 41.4188 31.7537 41.4188C30.9943 41.4188 30.373 40.7648 30.373 39.9655V29.0658C30.373 28.2665 30.9943 27.6125 31.7537 27.6125Z" fill="#1C452B" />
                <path d="M31.7537 22.09C32.5162 22.09 33.1343 22.7081 33.1343 23.4706C33.1343 24.2331 32.5162 24.8513 31.7537 24.8513C30.9912 24.8513 30.373 24.2331 30.373 23.4706C30.373 22.7081 30.9912 22.09 31.7537 22.09Z" fill="#1C452B" />
            </g>
            <defs>
                <clipPath id="clip0_70_82">
                    <rect width="63.5087" height="63.5087" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
